import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {StandardTypesService} from '../../../../../services/standard-types.service';
import {Response} from '@angular/http';
import {AdminService} from '../../../../../services/admin.service';
import {PrefixService} from '../../../../../services/frefix.service';

@Component({
  selector: 'app-add-standard-type',
  templateUrl: './add-standard-type.component.html',
  styleUrls: ['./add-standard-type.component.css']
})
export class AddStandardTypeComponentHead implements OnInit {
  newRuTypeName: string;
  newEnTypeName: string;
  successInfo = false;
  errorInfo = false;
  errorSix = false;
  errorTwelve = false;
  successEight = false;
  isLoaded = false;
  errMesg = false;
  typeMainGroup = null;


  constructor(public activeModal: NgbActiveModal,
              private standardTypeService: StandardTypesService,
              private prefixService: PrefixService,
              private adminService: AdminService) {
  }

  ngOnInit() {
    // this.isLoaded = false;
    this.errMesg = false;

    // if (this.typeMainGroup !== null) {
    //   this.isLoaded = true;
    // }

  }

  setTypeMainGroup(mainGroup) {
    this.typeMainGroup = mainGroup;
    this.isLoaded = true;
  }

  addNewType() {
    this.errMesg = false;
    this.successInfo = false;
    this.errorInfo = false;
    this.errorSix = false;
    this.errorTwelve = false;
    this.successEight = false;

    if (this.newRuTypeName.trim().length >= 3) {

      // Create new type object
      const newType = {
        ruName: this.newRuTypeName,
        enName: this.newRuTypeName,
        group: {
          id: this.typeMainGroup.id,
          name: this.typeMainGroup.name
        }
      };

      this.standardTypeService.addNewType(newType).subscribe(
        (response: any) => {
          if (response.status === 201) {
            this.successInfo = true;
            this.errorInfo = false;
            this.successEight = false;

            this.standardTypeService.getTypesList().push(response.body);
            this.standardTypeService.setSelectedType(response.body);
          } else if (response.status === 208) {
            this.successInfo = false;
            this.successEight = true;
            this.errorInfo = false;
          }
        },
        () => {
          this.successInfo = false;
          this.errorInfo = true;
          this.successEight = false;
        }
      );

    } else {
      this.errorSix = true;
    }

  }


}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-standard-head/modal/add-standard-type/add-standard-type.component.ts